export const COVERGO_SAAS_PROD = {
	COVERGO_GRAPHQL: "https://api.covergo.com/graphql",
	COVERGO_FILE_SYSTEM: "https://api.covergo.com/api/v1/files",
}

export const COVERGO_SAAS_DEV = {
	COVERGO_GRAPHQL: "https://api.dev.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.dev.covergo.cloud/api/v1/files",
}

export const COVERGO_EU_DEV = {
	COVERGO_GRAPHQL: "https://api.dev.eu.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.dev.eu.covergo.cloud/api/v1/files",
}

export const COVERGO_EU_PROD = {
	COVERGO_GRAPHQL: "https://api.eu.covergo.com/graphql",
	COVERGO_FILE_SYSTEM: "https://api.eu.covergo.com/api/v1/files",
}

export const COVERGO_EU_PREPROD = {
	COVERGO_GRAPHQL: "https://api.preprod.eu.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.preprod.eu.covergo.cloud/api/v1/files",
}

export const COVERGO_ASIA_PROD = {
	COVERGO_GRAPHQL: "https://api.asia.covergo.com/graphql",
	COVERGO_FILE_SYSTEM: "https://api.asia.covergo.com/api/v1/files",
}

export const COVERGO_ASIA_PRE_PROD = {
	COVERGO_GRAPHQL: "https://api.preprod.asia.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.preprod.asia.covergo.cloud/api/v1/files",
}